import { useAsyncExecutor2 } from "async-executor-hook";
import { differenceInDays, format } from "date-fns";
import { stringify } from "query-string";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";

import { Authorization } from "../../../common/AuthorizationCpt";
import {
  WCalendar,
  WInputText,
  WMultipleTagInput,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { removeNullProps } from "../../../common/utils";
import IconVectorRightBlue from "../../../images/icon_button_users_blue.svg";
import { AdminTurnConfirmationParams$ } from "./AdminTurnConfirmation.interface";

const AdminTurnConfirmationSearch = (props: AdminTurnConfirmationParams$) => {
  const { params$ } = props;
  const history = useHistory();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        agent_name: new FormControl(),
        volante_nums: new FormControl(),
        withdrawal_from_date: new FormControl(),
        withdrawal_to_date: new FormControl(),
      });
      form
        .get("withdrawal_from_date")
        .valueChanges.subscribe((withdrawal_from_date: Date) => {
          const withdrawalToDate =
            new Date(form.get("withdrawal_to_date").value) || new Date();
          const withdrawalDiffDate = differenceInDays(
            withdrawalToDate,
            new Date(withdrawal_from_date)
          );
          if (withdrawalDiffDate < 1) {
            form.get("withdrawal_to_date").setValue(withdrawal_from_date);
          }
        });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      const withdrawal_from_date =
        data.withdrawal_from_date &&
        format(data.withdrawal_from_date, "yyyy-MM-dd");
      const withdrawal_to_date =
        data.withdrawal_to_date &&
        format(data.withdrawal_to_date, "yyyy-MM-dd");
      const pathname = history.location.pathname;
      history.push(
        `${pathname}?${stringify(
          removeNullProps({ ...data, withdrawal_from_date, withdrawal_to_date })
        )}`
      );
    },
  });

  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (params) => {
      formConfig.loadSucceed(params);
    },
  });
  return (
    <Authorization actions={["appointment.get_appointment_admin_turn"]}>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-6 p-md-3">
            <WFormControl name="agent_name">
              <TemplateInputContainer label="Agente de aduana:">
                <WInputText width="100%" placeholder="Nombre del agente" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <WFormControl name="volante_nums">
              <TemplateInputContainer label="Volantes:">
                <WMultipleTagInput width="100%" height="5rem" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-2">
            <WFormControl name="withdrawal_from_date">
              <TemplateInputContainer label="Fecha de inicio:" color="#08082B">
                <WCalendar width="100%" dateFormat="dd/mm/yy" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-2">
            <WFormControl name="withdrawal_to_date">
              <TemplateInputContainer label="Fecha de fin:">
                <WCalendar
                  width="100%"
                  minDate={
                    formConfig.form?.get("withdrawal_from_date")?.value ||
                    new Date()
                  }
                  dateFormat="dd/mm/yy"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-2">
            <div style={{ marginBottom: "1.8rem", height: "1.4rem" }} />
            <SaveButton
              label="Aplicar filtros"
              width="100%"
              height="5rem"
              backgroundColor="#002E6C"
              iconRight={IconVectorRightBlue}
            />
          </div>
        </div>
      </WForm>
    </Authorization>
  );
};

export default AdminTurnConfirmationSearch;
